import React from 'react';
import LetterTile from '../letter-tile.jsx';
import { Topic } from '../../tinode/topic';
import lodash from 'lodash'
import { FormattedMessage, injectIntl } from 'react-intl';
import { IconCrown, IconInfo2, IconMinusPerson, IconThreeDots } from '../../icons/svg/index.js';
import { profile } from '../../stores/storages/ProfileStorage.js';
import { GROUP_ROLE } from '../../tinode/constants.js';
const messsages = {
  alert_confirm_add_admin_title: {
    id: "alert_confirm_add_admin_title",
    defaultMessage: "Grant administrator rights"
  },
  alert_confirm_remove_admin_title: {
    id: "alert_confirm_remove_admin_title",
    defaultMessage: "Remove the admin role"
  },
  alert_confirm_add_admin_desc: {
    id: "alert_confirm_add_admin_desc",
    defaultMessage: "Do you want to give admin rights to {username}"
  },
  alert_confirm_remove_admin_desc: {
    id: "alert_confirm_remove_admin_desc",
    defaultMessage: "Do you want to remove admin rights for {username}"
  },
  alert_confirm_leave_title: {
    id: "alert_confirm_leave_title",
    defaultMessage: "Invite {member} out of the group"
  },
  alert_confirm_leave_desc: {
    id: "alert_confirm_leave_desc",
    defaultMessage: "Are you sure you want to invite {member} out of this group?"
  }
}
class MemberItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.selfRef = React.createRef();

    this.state = {
      isShow: false
    }

    this.handleMouse = this.handleMouse.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.handleShowOrHiddenOption = this.handleShowOrHiddenOption.bind(this);
    this.renderOption = this.renderOption.bind(this);
    this.handleMakeAdmin = this.handleMakeAdmin.bind(this);
    this.handleDeleteMember = this.handleDeleteMember.bind(this);
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.handlePageClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handlePageClick, false);
  }

  handlePageClick(e) {
    if (this.selfRef.current.contains(e.target)) {
      return;
    }
    this.handleShowOrHiddenOption(false)
  }

  handleMouse() {
    if (event.which == 3) {
      this.handleShowOrHiddenOption(true)
    }
  }

  handleShowOrHiddenOption(boolean) {
    const { item } = this.props;
    const isMe = !!(item.jid == profile.username);
    if (isMe) {
      return;
    }
    this.setState({
      isShow: boolean
    })
  }

  handleMakeAdmin(role) {
    const { topic, tinode, item, onShowAlert } = this.props;
    const { formatMessage } = this.props.intl;
    const name = Topic.getTopicName(item);
    let title = (role == GROUP_ROLE.ADMIN) ? messsages.alert_confirm_add_admin_title : messsages.alert_confirm_remove_admin_title;
    let desc = (role == GROUP_ROLE.ADMIN) ? messsages.alert_confirm_add_admin_desc : messsages.alert_confirm_remove_admin_desc;
    onShowAlert(
      formatMessage(title), // title
      formatMessage(desc, {
        username: name
      }), // content
      (_ => { tinode.sendMakeAdmin(topic, item.jid, role); }), // onConfirm
      null, // "OK"
      true, // Show Reject button
      null  // "Cancel"
    );
  }

  handleDeleteMember() {
    const { topic, tinode, item, isAdmin } = this.props;
    const { formatMessage } = this.props.intl;
    const name = Topic.getTopicName(item);
    this.props.onShowAlert(
      formatMessage(messsages.alert_confirm_leave_title, {
        member: name
      }), // title
      formatMessage(messsages.alert_confirm_leave_desc, {
        member: name
      }), // content
      (_ => { tinode.sendKickMember(topic, item.jid, isAdmin ? GROUP_ROLE.ADMIN : GROUP_ROLE.MEMBER); }), // onConfirm
      null, // "OK"
      true, // Show Reject button
      null  // "Cancel"
    );
  }

  renderOption() {
    const { isShow, item } = this.state;
    const { isAdmin, handleClick, isAdminGr } = this.props;
    if (isShow) {
      return (
        <div className="option-admin">
          <div className="option" onClick={handleClick}>
            <div className="icon">
              <IconInfo2 />
            </div>
            <div className="title">
              <FormattedMessage
                id={'admin_option_info'}
                defaultMessage={'Information'}
              />
            </div>
          </div>
          {isAdminGr &&
            <React.Fragment>
              {isAdmin ?
                <div className="option" onClick={() => this.handleMakeAdmin(GROUP_ROLE.MEMBER)}>
                  <div className="icon">
                    <IconCrown />
                  </div>
                  <div className="title">
                    <FormattedMessage
                      id={'admin_option_remove_admin'}
                      defaultMessage={'Remove admin rights'}
                    />
                  </div>
                </div>
                :
                <div className="option" onClick={() => this.handleMakeAdmin(GROUP_ROLE.ADMIN)}>
                  <div className="icon">
                    <IconCrown />
                  </div>
                  <div className="title">
                    <FormattedMessage
                      id={'admin_option_add_admin'}
                      defaultMessage={'Add administrator rights'}
                    />

                  </div>
                </div>
              }
            </React.Fragment >
          }
          {isAdminGr &&
            <div className="option" onClick={this.handleDeleteMember}>
              <div className="icon">
                <IconMinusPerson />
              </div>
              <div className="title">
                <FormattedMessage
                  id={'admin_option_delete_member'}
                  defaultMessage={'Delete members'}
                />
              </div>
            </div>
          }
        </div>
      )
    }
  }

  render() {
    const { item, tinode } = this.props;
    const avatar = lodash.has(item, 'public.photo.ref') ? item.public.photo.ref : true;
    const title = Topic.getTopicName(item);
    const isMe = !!(item.jid == profile.username);
    return (
      <div
        className="item"
        ref={this.selfRef}
        onMouseDown={this.handleMouse}>
        <div className="avatar">
          <LetterTile
            tinode={tinode}
            avatar={avatar || true}
            title={title}
            topic={item.topic || item.user}
          />
        </div>
        <div className="name">{title}</div>
        {this.renderOption()}
        {!isMe ?
          <div className="dots" onClick={() => this.handleShowOrHiddenOption(true)}>
            <IconThreeDots />
          </div>
          :
          undefined
        }
      </div>
    )
  }
}

export default injectIntl(MemberItem);